import { Box, Flex, Link, Text } from "@chakra-ui/react"
import { Link as RouterLink } from "react-router-dom"
import { neutral, type, layout } from "../theme/tokens"

export default function Footer() {
  return (
    <Box as="footer" mt={6} px={layout.contentGutter} py={4} borderTop="1px solid" borderColor={neutral[200]}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        gap={2}
        fontSize={type.size.caption}
        color={neutral[400]}
      >
        <Text>© {new Date().getFullYear()} SpearBI · Spear Management</Text>
        <Flex gap={4}>
          <Link as={RouterLink} to="/terms" color={neutral[500]} _hover={{ color: neutral[800] }}>
            Terms
          </Link>
          <Link as={RouterLink} to="/privacy" color={neutral[500]} _hover={{ color: neutral[800] }}>
            Privacy
          </Link>
        </Flex>
      </Flex>
    </Box>
  )
}
